module.exports = __webpack_public_path__ + "img/solvency-yellow.51e9f036.svg";